import React, { memo } from 'react';
import { Col, Form, FormModal, Row, Select } from 'components';
import { ValidationErrors } from 'constants/validations';
import { Country } from 'models/Country';
import { ManagementRoleMapping } from 'models/Manager';
import { useAddEdit } from './useAddEdit';

interface IAddEdit {
  openModal: boolean;
  onModalStateChange: () => void;
  dataToEdit?: any;
}

export const AddEditSalesManagerModal = memo<IAddEdit>((props) => {
  const { openModal, dataToEdit, onModalStateChange } = props;
  const { form, handleSubmit, contextHolder, userData, countryData, disabledCountries, isEditMode, isLoadingUpdate } =
    useAddEdit({
      dataToEdit,
      onModalStateChange,
    });

  return (
    <>
      {contextHolder}
      <FormModal
        form={form}
        title={`${isEditMode ? 'Update' : 'Add'} Sales Manager`}
        okText={isEditMode ? 'Save' : 'Add'}
        open={openModal}
        isLoading={isLoadingUpdate}
        onCancel={() => {
          form.resetFields();
          onModalStateChange();
        }}
        onSubmit={handleSubmit}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Form.Item
              name="countries"
              label="Countries*"
              rules={[
                {
                  required: true,
                  message: ValidationErrors.required('Country'),
                },
              ]}
            >
              {/*<CountrySelect size={'large'}  mode={'multiple'} maxTagCount={'responsive'}/>*/}
              {/* TODO need to change this select to countrySelect*/}
              <Select
                mode={'multiple'}
                size={'large'}
                maxTagCount={'responsive'}
                options={(countryData || []).map((country: Country) => {
                  return {
                    label: country.commonName,
                    value: country.id,
                    disabled: disabledCountries?.includes(country.id),
                  };
                })}
                filterOption={(input, option) => {
                  if (option) {
                    const label: string = option.label?.toString() || '';
                    return label?.toLowerCase()?.includes(input?.toLowerCase());
                  }
                  return false;
                }}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={`${ManagementRoleMapping.salesManager}*`}
              name={'salesManagerId'}
              rules={[{ required: true, message: ValidationErrors.required('Sales Manager') }]}
            >
              <Select size={'large'} options={userData} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              shouldUpdate={(prevValues: any, currentValues: any) =>
                prevValues.salesManagerId !== currentValues.salesManagerId
              }
            >
              {({ getFieldValue, setFieldValue }) => {
                const postSalesManagerId = getFieldValue('salesManagerId');
                const postSalesManagerAssistantId = getFieldValue('salesManagerAssistantId');
                if (postSalesManagerId === postSalesManagerAssistantId) setFieldValue('salesManagerAssistantId', '');
                return (
                  <Form.Item label={ManagementRoleMapping.salesManagerAssistant} name={'salesManagerAssistantId'}>
                    <Select
                      size={'large'}
                      options={userData.map((i: { value: string; label: string }) => ({
                        ...i,
                        disabled: getFieldValue('salesManagerId') === i.value,
                      }))}
                      disabled={!getFieldValue('salesManagerId')}
                    />
                  </Form.Item>
                );
              }}
            </Form.Item>
          </Col>
        </Row>
      </FormModal>
    </>
  );
});
